import Margin from './Margin'
import HorizontalDivider from './HorizontalDivider'

const Spacing = {
    HorizontalDivider,
    Margin
}

export default Spacing
